module.exports = __webpack_public_path__ + "static/media/11-ungomsskole.84b17eeb.mp3";